/* Green Hunters, Produktfinder (Schicht A).
   Mehrschritt-Konfigurator nach Mockup-Referenz. Liest das serverseitig
   gerenderte Daten-JSON aus der Sektion. Kein Framework, IIFE, defer. */
(function () {
  'use strict';

  var DEFAULTS = {
    q_cat: 'Was suchst du?',
    h_cat: 'Wähle eine Kategorie, der Rest dauert nur ein paar Klicks.',
    c_oil: 'Ätherische Öle',
    c_oil_s: 'Für Entspannung, Energie, Haut und mehr',
    c_spice: 'Kräuter & Gewürze',
    c_spice_s: 'Authentischer Zaatar und Sumach',
    q_goals: 'Wofür möchtest du dein Öl nutzen?',
    h_multi: 'Mehrfachauswahl möglich.',
    q_duft: 'Welche Duftrichtung magst du?',
    h_duft: 'Mehrfachauswahl möglich, optional.',
    q_use: 'Wie möchtest du es anwenden?',
    h_use: 'Optional, hilft uns bei der Feinauswahl.',
    q_style: 'Worauf hast du Lust?',
    h_style: 'Wähle deine Lieblingsvariante.',
    weiter: 'Weiter', zurueck: 'Zurück', neu: 'Neu starten', step: 'Schritt', von: 'von',
    empf: 'Unsere Empfehlung', match: 'Dein perfektes Match', auch: 'Auch passend', ansehen: 'Produkt ansehen',
    spiceres: 'Das passt zu dir', allround: 'Unser Allrounder für dich',
    allround_r: 'Ein vielseitiger Klassiker, wenn du dich noch nicht festlegen möchtest.'
  };

  function esc(s) { return (s || '').replace(/"/g, '&quot;'); }
  function toggle(a, v) { var i = a.indexOf(v); if (i >= 0) a.splice(i, 1); else a.push(v); }

  // Bild-Tag mit width/height/srcset/lazy (gegen Layout-Shift, mobile-konform).
  function imgTag(o) {
    var a = 'src="' + esc(o.img) + '" alt="' + esc(o.name) + '" loading="lazy" decoding="async"';
    if (o.srcset) { a += ' srcset="' + esc(o.srcset) + '" sizes="' + esc(o.sizes || '') + '"'; }
    if (o.imgW) { a += ' width="' + o.imgW + '"'; }
    if (o.imgH) { a += ' height="' + o.imgH + '"'; }
    return '<img ' + a + '>';
  }

  function init(root) {
    var dataEl = root.querySelector('.gh-finder-data');
    var mount = root.querySelector('.gh-finder__root');
    if (!dataEl || !mount) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var STR = DEFAULTS;
    try { var parsed = JSON.parse(root.getAttribute('data-strings') || 'null'); if (parsed) STR = parsed; } catch (e2) {}
    var st = { step: 0, cat: null, goals: [], duft: [], usages: [], style: null };

    function steps() {
      if (st.cat === 'spice') return ['cat', 'style', 'result'];
      if (st.cat === 'oil') return ['cat', 'goals', 'duft', 'usages', 'result'];
      return ['cat'];
    }
    function chips(list, sel, act) {
      return '<div class="fchips">' + list.map(function (o) {
        var on = act === 'style' ? (st.style === o[0]) : (sel.indexOf(o[0]) >= 0);
        return '<button type="button" class="fchip' + (on ? ' is-active' : '') + '" data-act="' + act + '" data-val="' + o[0] + '">' + o[1] + '</button>';
      }).join('') + '</div>';
    }
    function bar() {
      var s = steps();
      return '<div class="cfg__bar">' + s.map(function (_, i) {
        return '<span class="cfg__dot' + (i <= st.step ? ' is-done' : '') + '"></span>';
      }).join('') + '</div><div class="cfg__step">' + STR.step + ' ' + (st.step + 1) + ' ' + STR.von + ' ' + s.length + '</div>';
    }
    function nav(canNext) {
      var back = st.step > 0 ? '<button type="button" class="cfg__back" data-act="back">' + STR.zurueck + '</button>' : '';
      return '<div class="cfg__nav"><button type="button" class="btn" data-act="next"' + (canNext ? '' : ' disabled') + '>' + STR.weiter + '</button>' + back + '</div>';
    }
    function recommend() {
      var best = [];
      for (var k in D.oils) {
        if (!D.oils.hasOwnProperty(k)) continue;
        var o = D.oils[k], sc = 0;
        st.goals.forEach(function (g) { if ((o.goals || []).indexOf(g) >= 0) sc += 2; });
        st.duft.forEach(function (d) { if ((o.aroma || []).indexOf(d) >= 0) sc += 1.5; });
        st.usages.forEach(function (u) { if ((o.usages || []).indexOf(u) >= 0) sc += 1; });
        best.push({ o: o, sc: sc });
      }
      best.sort(function (a, b) { return b.sc - a.sc; });
      return best;
    }
    // Grundpreis (PAngV) aus der Liquid-Map; leer, wenn die Variante keinen hat.
    function unitTag(o) {
      return o.unit ? '<span class="gh-unit">' + o.unit + '</span>' : '';
    }
    function recCard(o, reason) {
      return '<div class="finrec"><div class="finrec__img">' + imgTag(o) + '</div>'
        + '<div class="finrec__txt"><span class="eyebrow">' + STR.empf + '</span><h3>' + o.name + '</h3><p>' + (reason || o.reason || '') + '</p>'
        + '<div class="finrec__foot"><span class="gh-finder__price"><span class="price__now">' + o.price + '</span>' + unitTag(o) + '</span><a class="btn" href="' + (o.url || '#') + '">' + STR.ansehen + '</a></div></div></div>';
    }
    function altCard(o) {
      return '<a class="cfg__alt" href="' + (o.url || '#') + '">' + imgTag(o) + '<span><b>' + o.name + '</b><br><span>' + o.price + '</span>' + unitTag(o) + '</span></a>';
    }
    function render() {
      var cur = steps()[st.step], h = bar();
      if (cur === 'cat') {
        h += '<div class="cfg__q">' + STR.q_cat + '</div><div class="cfg__hint">' + STR.h_cat + '</div><div class="cfg__cats">'
          + '<button type="button" class="cfg__cat" data-act="cat" data-val="oil"><h4>' + STR.c_oil + '</h4><span>' + STR.c_oil_s + '</span></button>'
          + '<button type="button" class="cfg__cat" data-act="cat" data-val="spice"><h4>' + STR.c_spice + '</h4><span>' + STR.c_spice_s + '</span></button></div>';
      } else if (cur === 'goals') {
        h += '<div class="cfg__q">' + STR.q_goals + '</div><div class="cfg__hint">' + STR.h_multi + '</div>' + chips(D.goals, st.goals, 'goal') + nav(st.goals.length > 0);
      } else if (cur === 'duft') {
        h += '<div class="cfg__q">' + STR.q_duft + '</div><div class="cfg__hint">' + STR.h_duft + '</div>' + chips(D.duft, st.duft, 'duft') + nav(true);
      } else if (cur === 'usages') {
        h += '<div class="cfg__q">' + STR.q_use + '</div><div class="cfg__hint">' + STR.h_use + '</div>' + chips(D.usages, st.usages, 'usage') + nav(true);
      } else if (cur === 'style') {
        h += '<div class="cfg__q">' + STR.q_style + '</div><div class="cfg__hint">' + STR.h_style + '</div>' + chips(D.spice_opts, [], 'style');
      } else if (cur === 'result') {
        if (st.cat === 'spice') {
          var sp = D.spices[st.style] || D.spices.pur;
          h += '<div class="cfg__q">' + STR.spiceres + '</div>' + recCard(sp) + '<div class="cfg__nav"><button type="button" class="cfg__back" data-act="restart">' + STR.neu + '</button></div>';
        } else {
          var best = recommend();
          if (!best.length || best[0].sc === 0) {
            var firstKey = Object.keys(D.oils)[0];
            h += '<div class="cfg__q">' + STR.allround + '</div>' + recCard(D.oils[firstKey], STR.allround_r);
          } else {
            h += '<div class="cfg__q">' + STR.match + '</div>' + recCard(best[0].o);
            var altCount = (typeof D.altCount === 'number') ? D.altCount : 3;
            var alts = best.slice(1, 1 + altCount).filter(function (x) { return x.sc > 0; });
            if (alts.length) {
              h += '<div class="cfg__hint" style="margin-top:22px">' + STR.auch + '</div><div class="cfg__alts">' + alts.map(function (x) { return altCard(x.o); }).join('') + '</div>';
            }
          }
          h += '<div class="cfg__nav"><button type="button" class="cfg__back" data-act="restart">' + STR.neu + '</button></div>';
        }
      }
      mount.innerHTML = '<div class="cfg">' + h + '</div>';
    }

    mount.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]');
      if (!b) return; // Produkt-Links (<a>) navigieren normal
      var act = b.getAttribute('data-act'), val = b.getAttribute('data-val');
      if (act === 'cat') { st.cat = val; st.step = 1; }
      else if (act === 'goal') { toggle(st.goals, val); }
      else if (act === 'duft') { toggle(st.duft, val); }
      else if (act === 'usage') { toggle(st.usages, val); }
      else if (act === 'style') { st.style = val; st.step = 2; }
      else if (act === 'next') { st.step++; }
      else if (act === 'back') { st.step--; }
      else if (act === 'restart') { st.cat = null; st.goals = []; st.duft = []; st.usages = []; st.style = null; st.step = 0; }
      render();
    });

    render();
  }

  function boot() {
    var roots = document.querySelectorAll('.gh-finder');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
